export enum BookFormPhaseEnum {
  FORM_PAGE = 'FORM_PAGE',
  CREDIT_CARD_PAGE = 'CREDIT_CARD_PAGE',
  PAYMENT_PAGE = 'PAYMENT_PAGE',
  SUCCESS_PAGE = 'SUCCESS_PAGE',
  WAITING_LIST_SUCCESS_PAGE = 'WAITING_LIST_SUCCESS_PAGE',
}
